import { BlipChat } from 'blip-chat-widget';
import './WidgetHelpCenterBuilderView.scss';
//Constants
import { WidgetConstants, WidgetConstantsTracks } from './WidgetConstants';
import { widgetHelpCenterKey, widgetHelpCenterUri } from 'app.constants';
const WIDGET_MESSAGE_START = '#openWidget';
export class WidgetHelpBuilderController {
    static $inject = ['$translate', 'TranslateService', 'SegmentService', 'AuthenticationService', 'ApplicationService2', 'ChatBrainService', '$sce', '$cookies', 'StudioService'];
    constructor($translate, TranslateService, SegmentService, AuthenticationService, ApplicationService2, ChatBrainService, $sce, $cookies, StudioService) {
        'ngInject';
        this.$translate = $translate;
        this.TranslateService = TranslateService;
        this.SegmentService = SegmentService;
        this.AuthenticationService = AuthenticationService;
        this.ApplicationService2 = ApplicationService2;
        this.ChatBrainService = ChatBrainService;
        this.$sce = $sce;
        this.$cookies = $cookies;
        this.StudioService = StudioService;
        this.showMessage = true;
        this.showWidget = true;
        this.openBlipChat = false;
        this.openBlipChatAgent = false;
        this.buildChat = false;
        this.isLoading = false;
        this.closeMessageDelay = 4000;
        this.messages = [];
        this.newMessage = '';
        this.lastMessage = '';
        this.isTyping = false;
        this.isCheckBlipBrainEnabled = false;
    }
    async $onInit() {
        this.language = this.TranslateService.getCurrentLanguage();
        this.buildWidget();
        this.isCheckBlipBrainEnabled = await this.StudioService.shouldEnableStudioFeatures();
        this.ChatBrainService.onMessage(async (msg) => {
            if (msg) {
                await this.handleBotMessageAsync(msg);
                await this.scrollToBottomAsync();
            }
        });
    }
    async buildWidgetHelpBuilder() {
        if (widgetHelpCenterKey === '' || !widgetHelpCenterKey) {
            console.error('Blip chat key not found');
            return;
        }
        const widgetContainer = 'widget-help-center-container';
        const widgetIframe = 'blip-chat-iframe';
        const data = sessionStorage.getItem(WidgetConstants.WIDGET_HELP_CENTER_HAS_SESSION);
        this.widgetChat = new BlipChat()
            .withAppKey(widgetHelpCenterKey)
            .withCustomMessageMetadata({ pageOrigin: window.location.href })
            .withCustomCommonUrl(widgetHelpCenterUri)
            .withTarget(widgetContainer)
            .withEventHandler(BlipChat.LEAVE_EVENT, async () => {
            await this.closeChat();
            await this.SegmentService.createTrack(WidgetConstantsTracks.HELPBUILDER_WIDGET_CHAT_CLOSE, {});
        })
            .withEventHandler(BlipChat.LOAD_EVENT, async () => {
            const iframe = document.getElementById(widgetIframe);
            iframe?.contentWindow?.postMessage({ code: WidgetConstants.BLIP_CHAT_SHOW_CLOSE_BUTTON, showCloseButton: true }, iframe?.src);
            if (!data) {
                this.widgetChat.sendMessage({
                    type: 'text/plain',
                    content: WIDGET_MESSAGE_START,
                    metadata: {
                        '#blip.hiddenMessage': true,
                    },
                });
            }
            this.buildChat = true;
            this.isLoading = false;
            sessionStorage.setItem(WidgetConstants.WIDGET_HELP_CENTER_HAS_SESSION, 'true');
            await this.SegmentService.createTrack(WidgetConstantsTracks.HELPBUILDER_WIDGET_CHAT_OPEN, {});
            this.openBlipChat = true;
        });
        try {
            await this.widgetChat.build();
            const widgetChat = document.getElementById('blip-chat-open-iframe');
            if (widgetChat) {
                widgetChat.setAttribute('style', 'display:none');
            }
        }
        catch (error) {
            this.isLoading = false;
            console.error(error);
        }
    }
    async buildWidgetAgentBrain() {
        const widgetIframe = 'blip-chat-iframe';
        const widgetBrainContainer = 'widget-brain-center-container';
        const data = sessionStorage.getItem(WidgetConstants.WIDGET_HELP_CENTER_HAS_SESSION);
        const botId = await this.getBotId();
        const tenantId = this.getTenant();
        const userAccessToken = await this.AuthenticationService.token;
        const widgetChatAgent = new BlipChat();
        widgetChatAgent
            .withAppKey('YnJhaW40OjlmNDkxNDhmLTkxMmMtNDhjMy1hYWNkLTJkZWYxYWRiN2UzMA==')
            .withCustomCommonUrl('https://aiconsultancy.chat.blip.ai/')
            .withTarget(widgetBrainContainer)
            .withCustomStyle(`
                #blip-chat-header {
                    width: 100% !important;
                    height: 66px !important;
                }
                
                #blip-chat-header .blip-chat-bot-name {
                    font-size: 20px !important;
                    line-height: 18px !important;
                }
                
                #blip-chat-header .blip-chat-bot-status {
                    font-size: 13px !important;
                    font-weight: 300 !important;
                }

                .bubble.left {
                    color: white !important; 
                    background-color: #393939 !important; 
                    border-color: transparent !important;
                }
                .blip-card .bubble.right {
                    background-color: #FFFFFF0F !important;
                    border-color: transparent !important;
                    color: white !important; 
                }

                li div {
                    color: white !important;
                }
                #message-input {
                    background-color: #1F1F1F !important;
                }

                #message-input textarea {
                    background-color: #1F1F1F !important;
                    color: white !important;
                }
            `)
            .withEventHandler(BlipChat.LEAVE_EVENT, async () => {
            await this.closeChatBrain();
        })
            .withEventHandler(BlipChat.LOAD_EVENT, function () {
            const iframe = document.getElementById(widgetIframe);
            iframe?.contentWindow?.postMessage({ code: WidgetConstants.BLIP_CHAT_SHOW_CLOSE_BUTTON, showCloseButton: true }, iframe?.src);
            setTimeout(() => {
                widgetChatAgent.sendMessage({
                    to: 'brain4@msging.net',
                    'type': 'application/json',
                    'content': {
                        'type': 'session/authenticate',
                        'version': 'agents-copilot',
                        'bot_id': botId,
                        'tenant_id': tenantId,
                        'access_token': userAccessToken,
                    },
                    'metadata': {
                        '#blip.hiddenMessage': true,
                    },
                });
            }, 3000);
            this.buildChat = true;
            this.isLoading = false;
        });
        try {
            this.openBlipChatAgent = true;
            await widgetChatAgent.build();
            const widgetChatAgentIframe = document.getElementById('blip-chat-open-iframe');
            if (widgetChatAgentIframe) {
                widgetChatAgent.setAttribute('style', 'display:none');
            }
        }
        catch (error) {
            this.isLoading = false;
            console.error(error);
        }
    }
    getTenant() {
        const domain = window.location.host;
        const tenantId = domain.split('.')[0];
        return tenantId;
    }
    async getBotId() {
        try {
            const account = await this.ApplicationService2.getAccount();
            const botId = account.identity.split('@')[0];
            return botId;
        }
        catch {
            console.error('Error fetching bot ID');
        }
    }
    async openChat() {
        if (this.buildChat) {
            this.widgetChat.toogleChat();
            this.openBlipChat = true;
        }
        else {
            this.isLoading = true;
            await this.buildWidgetHelpBuilder();
        }
        this.showWidget = true;
    }
    async openChatAgent2() {
        if (this.buildChat) {
            this.openBlipChatAgent = true;
        }
        else {
            this.isLoading = true;
            await this.buildWidgetAgentBrain();
        }
        this.showWidget = true;
    }
    async toogleWidget() {
        const showWidgetBlip = !this.showWidget;
        localStorage.setItem(WidgetConstants.SHOW_WIDGET, `${showWidgetBlip}`);
        await this.SegmentService.createTrack(WidgetConstantsTracks.HELPBUILDER_WIDGET_BLIP, { showWidgetBlip });
        this.showWidget = showWidgetBlip;
        if (showWidgetBlip) {
            this.closeTimeoutMessageBublle();
            return;
        }
        this.showMessage = false;
    }
    buildWidget() {
        const data = localStorage.getItem(WidgetConstants.SHOW_WIDGET) !== 'false';
        if (!data) {
            this.showWidget = data;
            this.showMessage = false;
            return;
        }
        this.closeTimeoutMessageBublle();
    }
    async closeTimeoutMessageBublle() {
        this.showMessage = true;
        setTimeout(async () => {
            this.showMessage = false;
        }, this.closeMessageDelay);
    }
    async closeChat() {
        this.openBlipChat = false;
        this.closeTimeoutMessageBublle();
    }
    async refreshChatBrain() {
        this.isLoading = true;
        if (this.messages.length === 0) {
            this.isLoading = false;
            return;
        }
        this.messages = [];
        this.newMessage = '';
        try {
            await this.ChatBrainService.close();
            const botId = await this.getBotId();
            const cookie = this.$cookies.getObject(`blip-identity-${botId}`);
            if (cookie !== undefined) {
                try {
                    await this.$cookies.remove(`blip-identity-${botId}`, { path: '/' });
                }
                catch (err) {
                    console.error('Erro ao remover cookie', err);
                    throw err;
                }
            }
            await this.connectToBrain(true);
            this.openBlipChatAgent = true;
        }
        finally {
            this.isLoading = false;
        }
    }
    async closeChatBrain() {
        this.openBlipChatAgent = false;
        this.messages = [];
        this.newMessage = '';
    }
    async connectToBrain(isRefresh = false) {
        this.isLoading = true;
        try {
            const authData = this.AuthenticationService.getAuth();
            let issuer = authData?.issuer;
            if (issuer.indexOf('/v2.0/') > -1) {
                issuer = 'azure.blip.ai';
            }
            else {
                issuer = 'account.blip.ai';
            }
            const hostname = window.location.hostname;
            await this.ChatBrainService.connectAsGuest(await this.getBotId(), this.getTenant(), await this.AuthenticationService.token, issuer, hostname);
            const historic = await this.ChatBrainService.recoverMesssages();
            if (historic && !isRefresh) {
                const list = historic.resource.items.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
                for (const msg of list) {
                    if (msg.direction === 'sent' && msg.type === 'text/plain') {
                        this.addingMessageUser(msg.content);
                    }
                    if (msg.direction === 'received') {
                        await this.handleBotMessageAsync(msg);
                    }
                }
                await this.scrollToBottomAsync();
            }
        }
        catch (error) {
            console.error('Error connecting to Omni', error);
        }
    }
    async sendMessage(message) {
        if (!this.newMessage)
            return;
        this.lastMessage = this.newMessage;
        if (!message) {
            this.addingMessageUser(this.newMessage);
        }
        await this.ChatBrainService.sendMessage(message ? message : this.newMessage.replace(/\n/g, '<br>'));
        this.newMessage = '';
        await this.scrollToBottomAsync();
        setTimeout(() => {
            this.isTyping = true;
        }, 1500);
    }
    addingMessageUser(message) {
        const raw = message.replace(/\n/g, '<br>');
        const hasLink = /(https?:\/\/[^\s]+)/.test(raw);
        this.messages.push({
            from: 'user',
            text: hasLink ? null : raw,
            html: hasLink ? raw : null,
            date: new Date(),
        });
    }
    checkEnter(event) {
        if (event.key === 'Enter') {
            if (event.shiftKey) {
                return;
            }
            else {
                this.sendMessage();
                event.preventDefault();
            }
        }
    }
    async selectOption(option) {
        this.newMessage = option.text;
        await this.sendMessage();
    }
    async openChatAgent() {
        this.openBlipChatAgent = true;
        await this.connectToBrain();
    }
    handleBotMessageAsync(msg) {
        return new Promise(resolve => {
            this.handleBotMessage(msg);
            setTimeout(() => {
                this.isTyping = false;
                resolve();
            }, 0);
        });
    }
    handleBotMessage(msg) {
        if (msg.type == 'application/vnd.lime.web-link+json') {
            const botId = this.getBotId();
            const authData = this.AuthenticationService.getAuth();
            let issuer = authData?.issuer;
            if (issuer.indexOf('/v2.0/') > -1) {
                issuer = 'azure.blip.ai';
            }
            else {
                issuer = 'account.blip.ai';
            }
            const hostname = window.location.hostname;
            this.ChatBrainService.sendMessageWithMetadata(botId, this.getTenant(), this.AuthenticationService.token, issuer, hostname);
            this.sendMessage(this.lastMessage);
            return;
        }
        if (msg.type == 'application/vnd.lime.chatstate+json') {
            return;
        }
        if (msg.type === 'text/plain' && (msg.content !== '</ul>' && msg.content !== '<ul>')) {
            const html = this.$sce.trustAsHtml(msg.content.replace(/\n/g, '<br>'));
            this.messages.push({ from: 'bot', html, date: new Date() });
        }
        if (msg.type === 'application/vnd.lime.select+json') {
            const html = this.$sce.trustAsHtml(msg.content.text.replace(/\n/g, '<br>'));
            const options = msg.content.options || [];
            this.messages.push({ from: 'bot', html, options, isComponent: true, date: new Date() });
        }
        if (msg.type === 'application/vnd.lime.media-link+json') {
            const html = this.$sce.trustAsHtml(msg.content.title.replace(/\n/g, '<br>'));
            const uri = msg.content.uri;
            this.messages.push({ from: 'bot', html, uri, isComponent: true, date: new Date() });
        }
    }
    scrollToBottomAsync() {
        return new Promise(resolve => {
            setTimeout(() => {
                const container = document.getElementById('messagesContainer');
                if (container) {
                    container.scrollTo({
                        top: container.scrollHeight + 20,
                        behavior: 'smooth',
                    });
                }
                this.isLoading = false;
                resolve();
            }, 500);
        });
    }
}
WidgetHelpBuilderController.$inject = ['$translate', 'TranslateService', 'SegmentService', 'AuthenticationService', 'ApplicationService2', 'ChatBrainService', '$sce', '$cookies', 'StudioService'];
